import axiosRequest from '@/utils/axios-default-request';


/** 
 * 任务列表
 */
/**
 * 获取笔译项目列表
 * @param Long supUserId 供应商用户id
 * @back msgJlCount消息通知未读数量 feedbackCount意见反馈已处理未读数量 xxCount 未读信息总数量
 * */
let getBYProjectList = (data) => axiosRequest.postBody('/supinterface/getBYProjectList', data)

// 获取项目状态下拉列表 @ yuyan
let getTaskStateData = (data) => axiosRequest.postBody('/supinterface/getTaskStateData', data)

// 获取项目状态下拉列表 @ yuyan
let getProjectTypeData = (data) => axiosRequest.postBody('/supinterface/getProjectTypeData', data)

/**
 * 获取口译项目列表
 * @param Long supUserId 供应商用户id
 * @back 返回操作成功与失败的结果
 * */
let getKYProjectList = (data) => axiosRequest.postBody('/supinterface/getKYProjectList', data)

/**
* 获取项目详情
* String projectId  项目编号
* */
let getRWDTProjectDetail = (data) => axiosRequest.postBody('/supinterface/getRWDTProjectDetail', data)

/**
 * 申请任务大厅项目
 * ProjectApplicationJl projectApplicationJl实体类
{
    "supUserId": "1",供应商用户id
    "projectInfoId": "1",项目编号
    "projectType": "1",项目类型
    "expectedPrice": "12.51",期望价格
    "applicationDescription": "说明",说明
    "projectApplicationJlFileList": [ 文件
        {
            "fileName": "文件名称",
            "fileUrl": "文件路径"
        }
    ]
}
* 返回操作成功与失败的结果
 * */
let addProjectApplicationJL = (data) => axiosRequest.postBodyJson('/supinterface/addProjectApplicationJL', data)
/**
* 获取项目任务列表
* @param projectType  pageNum pageSize
*/
let uniqueApplicationRecord = (data) => axiosRequest.postBody('/supinterface/uniqueApplicationRecord', data)



/**
 * 获取项目任务列表
 * @param projectType  pageNum pageSize
 */
let getProjectReleaseInforList = (data) => axiosRequest.postBodyJson('/supinterface/getProjectReleaseInforList', data)


/**
 * 获取项目任务详情
 * @param projectType  pageNum pageSize
 */
let getProjectReleaseInforDetail = (data) => axiosRequest.postBody('/supinterface/getProjectReleaseInforDetail', data)

/**
 * 申请任务记录
 */


/**
 *获取申请任务大厅项目历史记录列表
 *Long supUserId  供应商用户id
String projectType 项目类型
 * */
let getProjectApplicationJLData = (data) => axiosRequest.postBody('/supinterface/getProjectApplicationJLData', data)

/**
 * 获取申请任务大厅项目历史记录详情
 * @param Long Long  supUserId 供应商id  projectInfoId  项目编号
 * */
let getProjectApplicationJLDetail = (data) => axiosRequest.postBody('/supinterface/getProjectApplicationJLDetail', data)



export default {
    /** 任务列表 */
    // getBYProjectList,//获取笔译项目列表
    // getKYProjectList,//获取口译项目列表
    getTaskStateData,//获取项目状态下拉列表
    getProjectTypeData,//获取项目类型
    getProjectReleaseInforList,//获取项目任务列表
    getProjectReleaseInforDetail,//获取项目详情
    addProjectApplicationJL,//申请任务大厅项目
    uniqueApplicationRecord,//获取是否申请过项目


    /** 申请任务记录 */
    getProjectApplicationJLData,//获取申请任务大厅项目历史记录列表
    getProjectApplicationJLDetail,//获取申请任务大厅项目历史记录详情

}